import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { TextField } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '15px 0px',
    textAlign: 'left'
  },
  textField: {
    '& > div > fieldset > legend': {
      display: 'block'
    }
  },
  subText: {
    margin: '8px 14px 0',
    fontSize: '0.75rem',
    color: theme.palette.text.subtext
  }
}))
const NmTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#FFFFFF'
    }
  }
})(TextField)

export const NmFormMultiline = (props) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <NmTextField
        className={classes.textField}
        name={props.name}
        variant='outlined'
        fullWidth
        rows={4}
        multiline
        onChange={props.onChange}
        value={props.value}
        onBlur={props.onBlur}
        label={props.label}
        error={props.error}
        helperText={props.helperText}
        select={props.select}
        required={props.required}
        type={props.type}
        disabled={props.disabled}
        defaultValue={props.defaultValue}
      >
        {props.children}
      </NmTextField>
      <span className={classes.subText}>{props.subText}</span>
    </div>
  )
}
